<it-card teaser="true" shadow="true">
  <div class="row">
    <div class="col">
      <it-alert color="danger">
        Confermi di voler ricominciare il percorso di arruolamento?
        Attenzione, l'operazione è irreversibile.
      </it-alert>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button itButton="outline-primary" type="button" (click)="cancel()">
          Torna indietro
        </button>
        <button
          itButton="danger"
          type="button"
          (click)="confirm()"
        >
          Conferma
        </button>
      </div>
    </div>
  </div>
</it-card>
